export class Offer {
    $key: string;
    club: {
        cid: string;
        city: string;
        clubName: string;
        country: string;
        state: string;
        location: {
            lat: number;
            lon: number;
        }
    }
    creationDate: number;
    image: string;
    longDescription: string;
    offerName: string;
    offerPrice: number;
    offerType: number;
    sellingPrice: number;
    shippingPrice: number;
    shortDescription: number;
    sold: number;
    status: number;
    stock: number;
    tnc: string;
    uid: string;
    validFrom: string;
    validTill: string;


}